module.exports = __webpack_public_path__ + "img/ic_tripadvisor-1.0.d2a93451.svg";